import { render } from "./Importar.vue?vue&type=template&id=efad06f2"
import script from "./Importar.vue?vue&type=script&lang=js"
export * from "./Importar.vue?vue&type=script&lang=js"

import "./Importar.vue?vue&type=style&index=0&id=efad06f2&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__